/*
 * PriorityIcon — colour-coded glyph for task priority.
 *
 * A tinted square frame holding a react-icon:
 *   Urgent  → TbUrgent  (red)
 *   High    → BiSignal5 (orange, all bars filled)
 *   Medium  → BiSignal3 (amber, three bars filled)
 *   Low     → BiSignal2 (blue,  two bars filled)
 *   None    → BsSlashCircle (slate, dimmed)
 */

import React from 'react';
import { TbUrgent } from 'react-icons/tb';
import { BiSignal2, BiSignal3, BiSignal5 } from 'react-icons/bi';
import { BsSlashCircle } from 'react-icons/bs';

const TONE = {
  Urgent: { border: '#fca5a5', bg: '#fef2f2', fg: '#dc2626' },
  High: { border: '#fdba74', bg: '#fff7ed', fg: '#ea580c' },
  Medium: { border: '#fcd34d', bg: '#fffbeb', fg: '#d97706' },
  Low: { border: '#93c5fd', bg: '#eff6ff', fg: '#2563eb' },
  None: { border: '#cbd5e1', bg: '#f8fafc', fg: '#64748b' }
};

const ICON = {
  Urgent: TbUrgent,
  High: BiSignal5,
  Medium: BiSignal3,
  Low: BiSignal2,
  None: BsSlashCircle
};

function PriorityIcon({ priority = 'None', size = 18, bare = false }) {
  const tone = TONE[priority] || TONE.None;
  const Icon = ICON[priority] || ICON.None;

  if (bare) {
    return <Icon size={size} color={tone.fg} aria-label={`${priority} priority`} />;
  }

  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: size,
        height: size,
        borderRadius: 4,
        border: `1px solid ${tone.border}`,
        background: tone.bg,
        flex: 'none'
      }}
      aria-label={`${priority} priority`}
    >
      <Icon size={size - 6} color={tone.fg} />
    </span>
  );
}

export default PriorityIcon;
